export default "__VITE_ASSET__BZovVl16__"